import { v4 as uuidv4 } from 'uuid';

function updateDevices(devices) {
    this.devices = devices;
    this.observed.devices = uuidv4();
}

export default updateDevices;
